import { render, staticRenderFns } from "./InformationCardValues.vue?vue&type=template&id=89a070d2&scoped=true&"
import script from "./InformationCardValues.vue?vue&type=script&lang=ts&"
export * from "./InformationCardValues.vue?vue&type=script&lang=ts&"
import style0 from "./InformationCardValues.vue?vue&type=style&index=0&id=89a070d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a070d2",
  null
  
)

export default component.exports